/**
 * Default API fetcher for query hooks.
 *
 * Uses the app's global axios instance so the existing Bearer-token
 * bridge (lib/tokenBridge.js — Safari ITP fallback + silent 401
 * refresh-and-retry) applies automatically. `withCredentials` keeps
 * cookie auth working for browsers that accept it.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** GET `${API_URL}/api${path}` and return response.data. */
export async function apiGet(path, config = {}) {
  const r = await axios.get(`${API_URL}/api${path}`, { withCredentials: true, ...config });
  return r.data;
}

/** Non-GET helper for mutations. */
export async function apiSend(method, path, body, config = {}) {
  const r = await axios.request({
    method,
    url: `${API_URL}/api${path}`,
    data: body,
    withCredentials: true,
    ...config,
  });
  return r.data;
}
